import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';


import { SimpleForm } from '@bingads-webui/simple-form';

import advancedOptionsTemplate from './advanced-opt-temp.pug';
import { pickModelPropertiesByFields } from '../parsers/index';

export const MAX_LABEL_LENGTH = 18;

export const AdvancedOptionsView = Backbone.View.extend({
  initialize({
    fields,
    schema,
    label,
    description,
    model,
    helpId,
    i18n,
  }) {
    this.i18n = i18n;

    this.form = new SimpleForm({
      schema,
      fields,
      showButtons: false,
      description,
      model: pickModelPropertiesByFields(model, fields),
    });

    this.label = label;
    this.advancedOptionsFields = fields;
    this.helpId = helpId;
    this.includeAllOption = false;
  },

  events() {
    return {};
  },

  areAllSelected() {
    return _.every(this.form.currentModel(), property => property);
  },

  areSomeSelected() {
    return _.some(this.form.currentModel(), property => property);
  },

  render() {
    this.$el.html(advancedOptionsTemplate({
      includeAllOption: false,
      label: _.size(this.label) > MAX_LABEL_LENGTH ? `${this.label.substring(0, MAX_LABEL_LENGTH)}...` : this.label,
      i18n: this.i18n,
      helpId: this.helpId,
      fullLabel: this.label,
    }));

    ko.applyBindings(this.viewModel, this.el);
    this.$('.advanced-options-form').html(this.form.render().$el);
    return this;
  },

  getCurrentModel() {
    return this.form.currentModel();
  },

  remove() {
    this.form.remove();
    Backbone.View.prototype.remove.call(this);
  },
});
